import React from 'react'
import GameFree from './Home/GameFree'

export default function FreeEdition(props) {

  const topStyle = {
    alignSelf: 'flex-start',position: 'relative', top: '12px'
  }

  const centerStyle = {
    alignSelf: 'center'
  }

  return (
    <div style={props.centerStyle ? centerStyle : topStyle}>
      {props.children.is_free_edition && <GameFree>{props.children}</GameFree>}
    </div>
  )
}
